import {agentConstants} from '../constants';

const agentState = {
  agentChatProps: { open: false, listenWebsocketConnection: false },
  flowGreetingMessages: {}
};

const agentReducer = (state = agentState, action) => {
  const {type, data} = action;
  switch (type) {
    case agentConstants.CLOSE_AGENT_CHAT:
      return {
        ...state,
        agentChatProps: { ...state.agentChatProps, open: false, listenWebsocketConnection: false, query: {} }
      }
    case agentConstants.OPEN_AGENT_CHAT:
      return {
        ...state,
        agentChatProps: { open: true, listenWebsocketConnection: true, ...data }
      }
    case agentConstants.UPDATE_AGENT_CHAT_PROPS:
      return {
        ...state,
        agentChatProps: { ...state.agentChatProps, ...data }
      }
    case agentConstants.CLEAR_AGENT_DATA:
      return {
        ...state,
        flowGreetingMessages: {}
      }
    case agentConstants.SET_FLOW_GREETING_MESSAGE:
      if (!data || !data.flow) return state;
      return {
        ...state,
        flowGreetingMessages: {
          ...state.flowGreetingMessages,
          [data.flow]: {message: data.message, quickActions: data.quickActions || []}
        }
      }
    default:
      return state;
  }
};

export default agentReducer;
